import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

import styles from "../push-modal.module.scss";

import {
  Button,
  LoadingIndicator,
  Select
} from "../../../../components/simple";
import { PLATFORMS } from "../platforms";

import Api from "../../../../api";

import usePrevious from "../../../../hooks/usePrev";
import LabelForRow from "../../../../components/forms/LabelForRow";

const Adform = ({
  // audienceType,
  // editAudienceHandler,
  selectedPlatform,
  handleSignin,
  isAuthorized,
  handlePushToPlatform
  // allowEdit
  // lineItemId,
  // handleLineItemChange
}) => {
  // const [selectedRadio, setSelectedRadio] = useState("");
  const platforms = useSelector(state => state.platforms);

  const [selectedData, setSelectedData] = useState({
    campaignId: "",
    lineitemId: ""
  });

  const [responseData, setResponseData] = useState({
    campaigns: [],
    lineitems: []
  });

  const [responseErrorMessage, setResponseErrorMessage] = useState({
    campaigns: "",
    lineitems: ""
  });

  const [adformIsAuthorized, setAdformIsAuthorized] = useState(false);

  const prevSelectedData = usePrevious(selectedData);

  const checkAdFormIsAuthorized = () => {
    Api.platforms.adform
      .isAuthorized()
      .then(res => {
        setAdformIsAuthorized(!!res?.valid);
      })
      .catch(error => {
        console.log(error);
      });
  };

  const getCampaigns = async () => {
    try {
      const campaigns = await Api.platforms.adform.getCampaigns();

      if (campaigns.message) {
        setResponseErrorMessage(prevState => ({
          ...prevState,
          campaigns: campaigns.message
        }));

        setResponseData({
          campaigns: [],
          lineitems: []
        });

        return;
      }

      setResponseData({
        campaigns,
        lineitems: []
      });
    } catch (error) {
      console.log(error);
    }
  };

  const getLineitems = async campaignId => {
    setSelectedData(prevData => ({
      ...prevData,
      lineitemId: ""
    }));

    setResponseErrorMessage(prevState => ({
      ...prevState,
      lineitems: ""
    }));

    try {
      const lineitems = await Api.platforms.adform.getLineitems({
        campaignId
      });

      if (lineitems.message) {
        setResponseErrorMessage(prevState => ({
          ...prevState,
          lineitems: lineitems.message
        }));

        setResponseData(prevData => ({
          ...prevData,
          lineitems: []
        }));

        return;
      }

      setResponseData(prevData => ({
        ...prevData,
        lineitems
      }));
    } catch (error) {
      console.log(error);
    }
  };

  const onSubmitHandler = e => {
    e.preventDefault();

    const { lineitemId } = selectedData;
    // const adFormFlow = selectedRadio === "AdForm Flow";

    // handlePushToPlatform(PLATFORMS.adform, { lineitemId, adFormFlow });
    handlePushToPlatform(PLATFORMS.adform, { lineitemId });
  };

  const handleSelectChange = (name, value) => {
    setSelectedData(prevData => ({
      ...prevData,
      [`${name}Id`]: value
    }));
  };

  // const onRadioChange = ({ target: { value } }) => {
  //   setSelectedRadio(value);
  // };

  useEffect(() => {
    checkAdFormIsAuthorized();
  }, []);

  /* eslint-disable react-hooks/exhaustive-deps */
  useEffect(() => {
    if (!responseData.campaigns.length && adformIsAuthorized) getCampaigns();
  }, [adformIsAuthorized]);
  /* eslint-enable react-hooks/exhaustive-deps */

  useEffect(() => {
    if (!isAuthorized || responseErrorMessage.campaigns) return;

    if (
      prevSelectedData?.campaignId !== selectedData.campaignId &&
      selectedData.campaignId
    ) {
      getLineitems(selectedData.campaignId);
    }
  }, [
    isAuthorized,
    selectedData,
    responseData,
    prevSelectedData,
    responseErrorMessage
  ]);

  return (
    <>
      <div
        className={`${styles["adform-signin"]} ${
          selectedPlatform === "adform" ? styles["slide-from-right"] : ""
        }`}
      >
        {/* <div className={styles["platform-logo"]}> */}
        {/*  <SVG.AdForm width={29} height={29} /> Adform */}
        {/* </div> */}
        <div className={styles["connect-account"]}>Connect Account</div>
        <Button
          className={styles["platform-signin-button"]}
          onClick={() => {
            handleSignin(PLATFORMS.adform);
          }}
        >
          Sign in to Adform
        </Button>
        <div className={styles["platform-description"]}></div>
      </div>
      <div
        className={` ${styles["adform-signin"]} ${
          selectedPlatform === "adform" && isAuthorized
            ? // selectedPlatform === "adform" && true
              styles["slide-from-right"]
            : ""
        }`}
      >
        <form onSubmit={onSubmitHandler}>
          {!responseErrorMessage.campaigns ? (
            <div style={{ marginTop: "30px" }}>
              <LabelForRow
                label="Choose the campaign you want to activate on"
                title="Pick Campaign"
              />
              <Select
                value={
                  selectedData.campaignId
                    ? {
                        label: "campaign",
                        value: selectedData.campaignId
                      }
                    : ""
                }
                selectForThePushForm
                className="push-platform"
                isSearchable
                label="Campaign"
                placeholder="Campaign Name"
                optionLabel="name"
                optionValue="id"
                options={responseData.campaigns}
                name="campaign"
                handleChange={handleSelectChange}
                required
              />
            </div>
          ) : (
            <p className={`${styles["select-error-mesage"]} mb-4 text-danger`}>
              {responseErrorMessage.campaigns}
            </p>
          )}

          {!responseErrorMessage.lineitems ? (
            <div style={{ marginTop: "30px" }}>
              <LabelForRow
                label="Choose the adset the audience needs to be added to"
                title="Pick Line Item"
              />
              <Select
                value={
                  selectedData.lineitemId
                    ? {
                        label: "lineitem",
                        value: selectedData.lineitemId
                      }
                    : ""
                }
                selectForThePushForm
                className="push-platform"
                isSearchable
                label="Line item ID"
                placeholder="Line Item Name"
                optionLabel="name"
                optionValue="id"
                options={responseData.lineitems}
                name="lineitem"
                handleChange={handleSelectChange}
                required
              />
            </div>
          ) : (
            <p className={`${styles["select-error-mesage"]} mb-4 text-danger`}>
              {responseErrorMessage.lineitems}
            </p>
          )}

          {/* <div className="mt-5">
            <p className="mb-4">Which AdForm version do you use?</p>

            <div className={`mb-2 ${styles.radio}`}>
              <label htmlFor="flow">
                <input
                  id="flow"
                  type="radio"
                  value="AdForm Flow"
                  checked={selectedRadio === "AdForm Flow"}
                  onChange={onRadioChange}
                />
                <span className="ml-2">AdForm Flow</span>
              </label>
            </div>

            <div className={`mb-2 ${styles.radio}`}>
              <label htmlFor="legacy">
                <input
                  id="legacy"
                  type="radio"
                  value="AdForm Legacy"
                  checked={selectedRadio === "AdForm Legacy"}
                  onChange={onRadioChange}
                />
                <span className="ml-2">AdForm Legacy</span>
              </label>
            </div>
          </div> */}

          {platforms?.isLoading ? (
            <div
              style={{ marginTop: "32px" }}
              className="mt-4 d-flex justify-content-center"
            >
              <LoadingIndicator />
            </div>
          ) : (
            <div className={styles.button_container}>
              <Button
                type="submit"
                className={styles["push-audience-btn"]}
                // disabled={!selectedData.lineitemId || !selectedRadio}
                disabled={!selectedData.lineitemId}
              >
                <span>Push</span>
              </Button>
              {/* {audienceType === "audience" && allowEdit && ( */}
              {/*  <Button */}
              {/*    type="button" */}
              {/*    className={`btn btn-secondary ${styles["edit-audience-btn"]}`} */}
              {/*    onClick={editAudienceHandler} */}
              {/*  > */}
              {/*    <span>Edit audience</span> */}
              {/*  </Button> */}
              {/* )} */}
            </div>
          )}
        </form>

        <div className={styles["platform-description"]}></div>
      </div>
    </>
  );
};

Adform.propTypes = {
  // audienceType: PropTypes.string.isRequired,
  selectedPlatform: PropTypes.string,
  handleSignin: PropTypes.func,
  isAuthorized: PropTypes.bool,
  handlePushToPlatform: PropTypes.func
  // lineItemId: PropTypes.string,
  // handleLineItemChange: PropTypes.func,
  // editAudienceHandler: PropTypes.func.isRequired,
  // allowEdit: PropTypes.bool.isRequired
};

Adform.defaultProps = {
  selectedPlatform: "",
  isAuthorized: false,
  handleSignin: () => {},
  handlePushToPlatform: () => {}
};

export default Adform;
